module.exports = __webpack_public_path__ + "static/media/blingV3_7.0bd6636f.png";